import builder from '../builder';
import SingleNeutralIDCard3 from '../../streamline-icons/light/single-neutral-id-card-3.svg';

export default builder('IconSingleNeutralIDCard3Light', SingleNeutralIDCard3);
